import { inject, Injectable, LOCALE_ID } from '@angular/core';
import { IntlMessageFormat } from 'intl-messageformat';

@Injectable({
  providedIn: 'root',
})
export class IcuLocalizationService {
  private readonly localeId = inject(LOCALE_ID);

  private escapeBoldTags(message: string): string {
    if (message.includes("'<b>'") || message.includes("'</b>'")) {
      return message;
    }

    return message.replace(/<\/?b>/g, (match) => `'${match}'`);
  }

  format(
    message: string,
    params: Record<string, any>,
    locale?: string,
  ): string {
    const endMessage = this.escapeBoldTags(message);

    const formatter = new IntlMessageFormat(
      endMessage,
      locale ? locale : this.localeId,
    );

    return formatter.format(params);
  }
}
